import React, { useEffect, useState } from "react";
import * as Notifications from "expo-notifications";
import * as Permissions from "expo-permissions";
import * as Segment from "../../analytics";

import Dialog from "../../components/Dialog";
import { useMutation } from "@apollo/client";
import { REGISTER_DEVICE } from "./gql";

type Props = {
  maybeOpen: boolean;
};

const EnablePushNotifications: React.FC<Props> = ({ maybeOpen }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [registerDevice, { loading }] = useMutation(REGISTER_DEVICE);

  const maybePrompt = async () => {
    const { status } = await Permissions.getAsync(Permissions.NOTIFICATIONS);

    console.log("maybePrompt for push status", status);

    if (status !== "granted") {
      setTimeout(() => setIsOpen(true), 500);
    }
  };

  const registerForPush = async () => {
    const { status } = await Permissions.askAsync(Permissions.NOTIFICATIONS);

    if (status !== "granted") {
      console.log("registerForPush status", status);
      return;
    }

    const token = await Notifications.getExpoPushTokenAsync();

    if (token) {
      Segment.track("Push Notifications Registered");
      await registerDevice({ variables: { input: { pushToken: token.data } } });
    }

    setIsOpen(false);
  };

  useEffect(() => {
    if (maybeOpen) {
      maybePrompt();
    }
  }, [maybeOpen]);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Enable notifications?"
      description="Would you like to enable push notifications for this and future visits?"
      confirmLabel="Enable notifications"
      onConfirm={() => registerForPush()}
      dismissLabel="No thanks"
      onDismiss={() => setIsOpen(false)}
      isLoading={loading}
    />
  );
};

export default EnablePushNotifications;
